module.exports = __webpack_public_path__ + "img/info-icon-yellow.ad4cae14.svg";